webpackJsonp([8],{

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_arfolyam_service__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aktualis_arfolyamok_pug__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aktualis_arfolyamok_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__aktualis_arfolyamok_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aktualis_arfolyam_tabla_aktualis_arfolyam_tabla__ = __webpack_require__(533);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Aktuális árfolyamokat lekérdező komponens
 * @author Erik Banhalmi 2017.05.17.
 */



var MODULE_NAME = 'aktualisArfolyamok';

var AktualisArfolyamokController = function () {
	AktualisArfolyamokController.$inject = ['arfolyamService', '$rootScope'];

	function AktualisArfolyamokController(arfolyamService, $rootScope) {
		'ngInject';

		_classCallCheck(this, AktualisArfolyamokController);

		this.arfolyamService = arfolyamService;
		this.rootScope = $rootScope;
		this.showLoader = false;
		this.notEnoughData = false;
	}

	AktualisArfolyamokController.prototype.$onInit = function $onInit() {
		var _this = this;

		this.showLoader = true;
		this.arfolyamService.getAktualisArfolyamok().then(function (response) {
			_this.showLoader = false;
			_this.aktualisArfolyam = response.data;
			if (!_this.aktualisArfolyam.length) {
				_this.notEnoughData = true;
			}
		}, function (error) {
			_this.showLoader = false;
			_this.rootScope.$broadcast('serverError');
			_this.error = error;
		});
	};

	return AktualisArfolyamokController;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (angular.module(MODULE_NAME, [__WEBPACK_IMPORTED_MODULE_0__services_arfolyam_service__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__aktualis_arfolyam_tabla_aktualis_arfolyam_tabla__["a" /* default */]]).component('aktualisArfolyamok', {
	controller: AktualisArfolyamokController,
	template: __WEBPACK_IMPORTED_MODULE_1__aktualis_arfolyamok_pug___default()(),
	bindings: {}
}).name);

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * arfolyam service az árfolyamok lekérdezéshez tartozó servie
 * @author István Rózsa 2017.05.16.
 */

var MODULE_NAME = 'arfolyamService';

var ArfolyamService = function () {
	ArfolyamService.$inject = ['$http'];

	function ArfolyamService($http) {
		'ngInject';

		_classCallCheck(this, ArfolyamService);

		this.$http = $http;
		this.apiRoot = '/api';
	}

	ArfolyamService.prototype.getAktualisArfolyamok = function getAktualisArfolyamok() {
		return this.$http.get(this.apiRoot + '/arfolyam/aktualis');
	};

	ArfolyamService.prototype.getTekozForInterval = function getTekozForInterval(dates) {
		return this.$http.post(this.apiRoot + '/arfolyam/tekoz', dates);
	};

	ArfolyamService.prototype.getArfolyam = function getArfolyam(dates) {
		return this.$http.post(this.apiRoot + '/arfolyam', dates);
	};

	ArfolyamService.prototype.getTekozInitDates = function getTekozInitDates() {
		return this.$http.get(this.apiRoot + '/arfolyam/tekoz/init');
	};

	ArfolyamService.prototype.getTekozForDate = function getTekozForDate() {
		return this.$http.get(this.apiRoot + '/arfolyam/tekoz');
	};

	ArfolyamService.prototype.getSzolgaltatasForDate = function getSzolgaltatasForDate() {
		return this.$http.get(this.apiRoot + '/arfolyam/szolgaltatasi');
	};

	ArfolyamService.prototype.getSzolgaltatasiForDate = function getSzolgaltatasiForDate(date) {
		return this.$http.get(this.apiRoot + '/arfolyam/szolgaltatasi');
	};

	ArfolyamService.prototype.getGrafikonInitDates = function getGrafikonInitDates() {
		return this.$http.get(this.apiRoot + '/arfolyam/init');
	};

	ArfolyamService.prototype.getPortfolioChartAdatok = function getPortfolioChartAdatok(responseData) {

		if (responseData.portfolios.length && responseData.portfolios[0].data.length < 2) {
			return null;
		}

		var colors = ['#52ae30', '#8946ae', '#ff6600', '#84ff8c', '#2950ff', '#1bffed'];
		var reformattedDataArray = responseData.dates.map(function (date) {
			var monthForUtc = parseInt(date.substring(4, 6)) - 1; // hónapok számozását az UTC 0-val kezdi
			return Date.UTC(date.substring(0, 4), monthForUtc, date.substring(6, 8));
		});

		var graphSeries = [];
		var graphData = [];
		for (var j = 0; j < responseData.portfolios.length; j++) {
			for (var i = 0; i < reformattedDataArray.length; i++) {
				graphData.push([reformattedDataArray[i], responseData.portfolios[j].data[i]]);
			}
			var obj = {
				name: responseData.portfolios[j].name,
				data: graphData,
				color: colors[j],
				linkedTo: j
			};

			var linkedObj = {
				data: [],
				name: responseData.portfolios[j].name,
				id: j,
				color: colors[j],
				marker: {
					enabled: true,
					symbol: 'square',
					radius: 10
				}
			};

			graphSeries.push(obj);
			graphSeries.push(linkedObj);
			graphData = [];
		}

		return {
			chart: {
				type: 'line',
				marginTop: 60
			},
			plotOptions: {
				series: {
					marker: {
						enabled: false
					},
					events: {
						legendItemClick: function legendItemClick() {
							return false;
						}
					}
				}
			},
			title: {
				text: ''
			},
			yAxis: {
				title: {
					text: ''
				},
				opposite: true
			},
			xAxis: {
				type: 'datetime',
				title: {
					text: ''
				},
				labels: {
					formatter: function formatter() {
						return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value).format("YYYY.MM.DD");
					}
				}
			},
			tooltip: {
				headerFormat: '<b>{series.name}</b><br>',
				pointFormat: '{moment(point.x).format("YYYY.MM.DD")}{point.y:.2f}',
				formatter: function formatter() {
					var formattedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.x).format('YYYY.MM.DD');
					return '<span style="font-size=10">' + formattedDate + '</span><br/>\n\t\t\t\t\t\t\t<span style="color:' + this.color + '">\u25CF</span>\n\t\t\t\t\t\t\t<span style="font-weight:bold">' + this.y + '</span>';
				}
			},
			legend: {
				align: 'left',
				verticalAlign: 'bottom',
				backgroundColor: '#FFFFFF',
				itemMarginBottom: 10
			},
			series: graphSeries
		};
	};

	return ArfolyamService;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).service('arfolyamService', ArfolyamService).name);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aktualis_arfolyamok_aktualis_arfolyam_tabla_aktualis_arfolyam_tabla_pcss__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aktualis_arfolyamok_aktualis_arfolyam_tabla_aktualis_arfolyam_tabla_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__aktualis_arfolyamok_aktualis_arfolyam_tabla_aktualis_arfolyam_tabla_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aktualis_arfolyamok_aktualis_arfolyamok_aktualis_arfolyamok_js__ = __webpack_require__(295);



/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aktualis_arfolyam_tabla_pug__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aktualis_arfolyam_tabla_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__aktualis_arfolyam_tabla_pug__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Az aktuális árfolyamokat táblázatban megjelenítő komponens
 * @author Erik Banhalmi 2017.05.17.
 */

var MODULE_NAME = 'aktualisArfolyamTabla';

var AktualisArfolyamTablaController = function () {
	function AktualisArfolyamTablaController() {
		'ngInject';

		_classCallCheck(this, AktualisArfolyamTablaController);
	}

	AktualisArfolyamTablaController.prototype.$onChanges = function $onChanges(changeObject) {
		if (!changeObject.aktualis.isFirstChange()) {
			this.aktualisArfolyam = angular.copy(this.aktualis);
		}
	};

	return AktualisArfolyamTablaController;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).component('aktualisArfolyamTabla', {
	controller: AktualisArfolyamTablaController,
	template: __WEBPACK_IMPORTED_MODULE_0__aktualis_arfolyam_tabla_pug___default()(),
	bindings: {
		aktualis: '<'
	}
}).name);

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-aktualis-arfolyam-tabla\"\u003E\u003Cdiv class=\"table-container\"\u003E\u003Ctable\u003E\u003Ccaption class=\"sr-only\"\u003EAz egyes portfólióink aktuális árfolyamai\u003C\u002Fcaption\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth scope=\"col\"\u003EÁrfolyam kelte\u003C\u002Fth\u003E\u003Cth scope=\"col\" id=\"kockazatkeruloPortfolio\"\u003EKockázatkerülő portfólió\u003C\u002Fth\u003E\u003Cth scope=\"col\" id=\"klasszkusPortfolio\"\u003EKlasszikus portfólió\u003C\u002Fth\u003E\u003Cth scope=\"col\" id=\"ovatosPortfolio\"\u003EÓvatos portfólió\u003C\u002Fth\u003E\u003Cth scope=\"col\" id=\"kiegyensulyozottPortfolio\"\u003EKiegyensúlyozott portfólió\u003C\u002Fth\u003E\u003Cth scope=\"col\" id=\"novekedesiPortfolio\"\u003ENövekedési portfólió\u003C\u002Fth\u003E\u003Cth scope=\"col\" id=\"dinamikusPortfolio\"\u003EDinamikus portfólió\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E\u003Ctr ng-repeat=\"rows in $ctrl.aktualisArfolyam | orderBy: rows.pdate\"\u003E\u003Cth scope=\"row\" id=\"pdate_{{ rows.pdate }}\"\u003E{{ rows.pdate | dateFormat }}\u003C\u002Fth\u003E\u003Ctd headers=\"pdate_{{ rows.pdate }} kockazatkeruloPortfolio\"\u003E{{ rows.kockazatkeruloPortfolio ? (rows.kockazatkeruloPortfolio | number:6) : '-' }}\u003C\u002Ftd\u003E\u003Ctd headers=\"pdate_{{ rows.pdate }} klasszkusPortfolio\"\u003E{{ rows.klasszkusPortfolio ? (rows.klasszkusPortfolio | number:6) : '-' }}\u003C\u002Ftd\u003E\u003Ctd headers=\"pdate_{{ rows.pdate }} ovatosPortfolio\"\u003E{{ rows.ovatosPortfolio ? (rows.ovatosPortfolio | number:6) : '-' }}\u003C\u002Ftd\u003E\u003Ctd headers=\"pdate_{{ rows.pdate }} kiegyensulyozottPortfolio\"\u003E{{ rows.kiegyensulyozottPortfolio ? (rows.kiegyensulyozottPortfolio | number:6) : '-' }}\u003C\u002Ftd\u003E\u003Ctd headers=\"pdate_{{ rows.pdate }} novekedesiPortfolio\"\u003E{{ rows.novekedesiPortfolio ? (rows.novekedesiPortfolio | number:6) : '-' }}\u003C\u002Ftd\u003E\u003Ctd headers=\"pdate_{{ rows.pdate }} dinamikusPortfolio\"\u003E{{ rows.dinamikusPortfolio ? (rows.dinamikusPortfolio | number:6) : '-' }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cloader ng-if=\"$ctrl.showLoader\"\u003E\u003C\u002Floader\u003E\u003Caktualis-arfolyam-tabla ng-show=\"!$ctrl.showLoader &amp;&amp; !$ctrl.notEnoughData\" aktualis=\"$ctrl.aktualisArfolyam\"\u003E\u003C\u002Faktualis-arfolyam-tabla\u003E\u003Cdiv ng-show=\"$ctrl.notEnoughData\"\u003ENincs adat.\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ })

},[532]);


// WEBPACK FOOTER //
// application/aktualis-arfolyamok.bundle.js